import axiosInstance from "./axiosInstance";
import { API_PATHS } from "./apiPaths";


const uploadImage = async (imageFile) => {
           const formData = new FormData();
           formData.append('image', imageFile);
           //handle image upload
           try {
              const response = await axiosInstance.post(API_PATHS.IMAGE.UPLOAD, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }});
                return response.data
            }
           catch (error) {
             console.error("Image upload failed:", error);
             throw error; // Propagate the error to be handled by the caller
            
            }}


export default uploadImage;